import { Injectable, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { catchError, filter, mergeMap, EMPTY } from 'rxjs';
import { Condominium } from '../../../../generated-sources/openapi/model/condominium';
import { House } from '../../../../generated-sources/openapi/model/house';
import { InvitationDetail } from '../../../../generated-sources/openapi/model/invitationDetail';
import { SignalrService } from './signalr.service';
import { MonitoringService } from '../../../../generated-sources/openapi/api/monitoring.service';
import { LoginService } from './login.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SearchStateService {
  private signalrService = inject(SignalrService);
  private monitoringService = inject(MonitoringService);
  private authService = inject(LoginService);

  private readonly INVITATIONS_KEY = 'frakcio-monitoring-invitations';

  condominiums = signal<Condominium[]>([]);
  houses = signal<House[]>([]);
  idCondominium = signal<number | null>(null);
  idHouse = signal<number | null>(null);
  lstInvitations = signal<InvitationDetail[]>(this.loadInvitationsFromStorage());

  constructor() {


  // Escuchar mensajes de QR desde SignalR y obtener la invitación correspondiente
  // realiza una solicitud a frakcio para obtener la info de la invitación recibida a la lecutura de QR
    toObservable(this.signalrService.qrMessage)
      .pipe(
        filter(cardNo => !!cardNo && (cardNo as string).trim() !== ''), // si es null o sólo espacios, no hacer nada
        mergeMap(cardNo =>
          this.monitoringService.monitoringInvitationQRInvitationQrStringGet(
            this.authService.getToken() ?? '',
            (cardNo as string).trim()
          ).pipe(
            catchError(err => {
              console.error('Error al obtener la invitación por QR:', err);
              return EMPTY;
            })
          )
        ),
        takeUntilDestroyed()
      )
      .subscribe(response => {
        if (response.data) {
          this.addInvitation(response.data);
        }
      });

  }

  setCondominiums(list: Condominium[]): void {
    this.condominiums.set(list);
  }

  setHouses(list: House[]): void {
    this.houses.set(list);
  }

  setCondominium(id: number | null): void {
    this.idCondominium.set(id);
    this.idHouse.set(null);
    this.houses.set([]);
  }

  setHouse(id: number | null): void {
    this.idHouse.set(id);
  }

  addInvitation(invitation: InvitationDetail): void {
    this.lstInvitations.update(list => {
      const updated = [invitation, ...list].slice(0, environment.MAX_INVITATIONS);
      localStorage.setItem(this.INVITATIONS_KEY, JSON.stringify(updated));
      return updated;
    });
  }

  private loadInvitationsFromStorage(): InvitationDetail[] {
    try {
      const stored = localStorage.getItem(this.INVITATIONS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }
}
